const menuItemChildrenToggles = document.querySelectorAll(
  '.MenuItem-childrenToggle',
)

function toggleMenuItemChidlren(toggleButton) {
  console.log(toggleButton)
  const expanded = toggleButton.getAttribute('aria-expanded') === 'true'

  toggleButton.setAttribute('aria-expanded', !expanded)
  document.getElementById(toggleButton.getAttribute('aria-controls')).hidden =
    expanded
}

if (menuItemChildrenToggles) {
  Array.prototype.forEach.call(menuItemChildrenToggles, function (toggle) {
    toggle.addEventListener('click', function () {
      toggleMenuItemChidlren(this)
    })
  })
}
